var errMsg = {
 isRequiredMessage : "このフィールドは必須です。",
 isCorrectNumberMessage1 : "円～",
 isCorrectNumberMessage2 : "円の数字を入力してください。",
 isAvailableNumberMessage : "500円以上50000円以下で入力してください。",
 isAlphaNumberMessage : "桁以内の半角英数字を入力してください。",
 isEmailMessage : "有効なEメールアドレスを入力してください。",
 isEqualToMessage : "同じ値をもう一度入力してください。",
 isPictographMessage : "入力禁止文字が入力されています。",
 isNotAllowedIllegalCharacterMessage : "入力禁止文字が入力されています。",
 isNotEqualToMessage : "とは別の値を入力して下さい。",
 senderAddressMessage : "贈り主のEメールアドレス",
 receiveAddressMessage : "お届け先のEメールアドレス",
 isOtpPasswordMessage : "セキュリティ番号を数字3桁で入力してください。"
}

var validation = {
    
    // validate判定詳細（バリアブル金額）
    isRequired : function(element) {
        return ($(element).val() !== null && $(element).val() !== "");
    },

    // validate判定詳細（バリアブル金額）
    isCorrectNumber: function(element, min, max) {
        if(/^[0-9]+$/.test($(element).val())) {
            if(min <= $(element).val()) {
                if($(element).val() <= max) {
                    return true;
                }
            }
            return false;
        } else {
            return false;
        }
    },

    // validate判定詳細（クーポンコード）
    isAlphaNumber: function(element, length) {
        var regex = new RegExp("^[A-Za-z0-9]{0," + length + "}$");
        return (regex.test($(element).val()));
    },
    // ワンタイムパスワードチェック
    isOtpPassword: function (element) {
        var regex = new RegExp("^[0-9]{3}$");
        return (regex.test($(element).val()));
    },
    // 半角記号は含まれるかチェック
    isHankakuSymbol: function(element){
        var regex = /[!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]/;
        return (regex.test($(element).val()));
    },
    // 半角カタカナは含まれるかチェック
    isHankakuKatakata: function(element){
        var regex = /[ｱ-ﾝ]/;
        return (regex.test($(element).val()));
    },

    // validate判定詳細（ギフト）
    isEmail : function(element) {
        var regex = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
        return (regex.test($(element).val()));
    },

    isEqualTo : function(element1, element2) {
        return ($(element1).val() == $(element2).val());
    },

    //絵文字
    isPictograph : function(element){
    	if($(element).val()) {
    		var pictograph = ($(element).val()).match(/\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]|\ud7c9[\ude00-\udeff]|[\u2600-\u27BF]/gi);
    		if (pictograph === null) return true;
    	}
        return false;
    },
    isNotAllowedIllegalCharacter : function(element) {
        var illegalCharactersB = "～∥－￠￡￢①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡㍻〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮Σ√⊥∠∟⊿∵∩∪？";
        var regex = new RegExp("^(?!.*[" + illegalCharactersB + "]).*");
        return (regex.test($(element).val()));
    },
    isFirstCharacterIsEnter : function(element) {
        var firstCharacter = $(element).val().substring(0, 1);
        return firstCharacter == '\n';
    },
    isNotEqualTo : function(element1, element2) {
        return (($(element1).val() !== $(element2).val()));
    },

    /**
    * 要素内がcheckedなっているかどうか判定する
    * @param 要素名
    * @return 要素名に一致する要素が、checkedだったらtrue、それ以外はfalseを返却する
     */
    isSelected : function(values) {
        var result = false;
        values.each(function(i, elem) { 
            if($(elem).prop("checked")) {
                result = true;
            } 
        })
        return result;
    },

    /**
     * チェックボックスにチェックが入っている場合はtrue。入っていない場合はfalse。
    * @param 要素名
    * @return 要チェックボックスにチェックが入っている場合はtrue。入っていない場合はfalse。
     */
    isChecked : function(element) {
        return $(element).prop("checked");
    },
    
    /**
     * Componentのステータスがfalseの場合、エラーメッセージ表示領域にエラーを表示する。
     * @param  {Component} component
     * @param  {string} errorMessage
     */
    errorCheck : function(component, errorMessage) {
        $(component.errDomId + ' > div.req-on').remove();
        if(errorMessage === '') {
            return true;
        } else {
            $(component.errDomId).prepend('<div class="req-on">'+errorMessage+'</div>');
            return false;
        }
    }
}
